export {
  mapDocumentCreateModelToFhir,
  mapDocumentReferenceToModel,
} from './mapping';
export type {
  Document,
  DocumentClinicalReferral,
  DocumentCreate,
  DocumentGetAllResponse,
  DocumentHomeBasedCareReferral,
  DocumentMotivationMedicalDevice,
  DocumentSearch,
} from './schema';
export {
  DocumentClinicalReferralSchema,
  DocumentCreateMedicationScriptSchema,
  DocumentCreateMedicationUsageSchema,
  DocumentCreateSchema,
  DocumentGetAllResponseSchema,
  DocumentHomeBasedCareReferralSchema,
  DocumentMotivationMedicalDeviceSchema,
  DocumentSchema,
  DocumentSearchSchema,
  DocumentTypeSchema,
  documentExtensions,
  documentStatus,
  FileExtensionDocumentSchema,
} from './schema';
